import React from 'react';

import Cancel from '@material-ui/icons/Cancel';

import styles from './index.module.scss';

import Grid from '../Grid';

import jpg from '../../../assets/img/file-upload/jpg.png';
import png from '../../../assets/img/file-upload/png.png';
import word from '../../../assets/img/file-upload/word.png';
import pdf from '../../../assets/img/file-upload/pdf.png';

import { PDF, DOC, DOCX, JPEG, PNG } from '../../../constants/file-upload';

import Button from '../Button';

const TYPES_ICONS = {
  [PDF]: pdf,
  [DOC]: word,
  [DOCX]: word,
  [JPEG]: jpg,
  [PNG]: png,
};

export default ({ file, onRemove, removeButtonId }) =>
  file ? (
    <Grid container alignItems="center" className={styles['file-preview']}>
      <Grid
        item
        container
        justify="space-between"
        className={styles['file-preview__image']}
      >
        <img src={TYPES_ICONS[file.type]} alt="file-type" />
        {onRemove ? (
          <Button
            id={removeButtonId}
            onClick={onRemove}
            variant="icon"
            className={styles['file-preview__remove']}
          >
            <Cancel />
          </Button>
        ) : null}
      </Grid>
      <Grid item className={styles['file-preview__label']}>
        {file.name}
      </Grid>
    </Grid>
  ) : null;
